import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const reviewSwiper = new Swiper( '.reviews__swiper', {
  a11y: true,
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
    }
  },
} );
